"use strict";

import variable from './variable';


(function ($) {
    var menuTimeout = undefined;
    var position = 0;
    var el = $(window);

    $(document).ready(function () {
        if ($('html').hasClass('fp-enabled')) {
            el = '#normal-page';
        }
        init(el);
    });

    $(window).resize(function () {
        init(el);
    });

    function init(el)
    {
        $(el).scroll(function () {
            if ($(document).width() > 1024) {
                var scroll = $(el).scrollTop();

                if (scroll > position) {
                    if ($('body').hasClass('menu-collapse')) {
                        $('#toggle-nav-main-open').click();
                    }
                } else {
                    clearTimeout(menuTimeout);
                    if (!$('body').hasClass('menu-collapse')) {
                        $('#toggle-nav-main-open').click();
                    }

                    menuTimeout = menuTrigger();
                }
                position = scroll;
            }
        });

    }

    function menuTrigger()
    {
        menuTimeout = setTimeout(()=>{
            if ($('body').hasClass('menu-collapse')) {
                $('#toggle-nav-main-open').click();
            }
        }, 3000);

        $('#nav-full-box').on('mouseenter', function () {
            clearTimeout(menuTimeout);
        });

        return menuTimeout;
    }
})(jQuery);
